export default "__VITE_ASSET__TuZrB72J__"